import { Observable, of, map, catchError } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function canParticipateEvent(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Can Participate Event',
    description: 'Check if user can participate in a specific event based on event privacy settings',
    requiresContext: true,
    execute: (context?: any) => {
      
      // Get event ID from context or extract from current URL
      let eventId = context?.eventId;
      
      if (!eventId) {
        // Try to extract event GUID from current URL
        const currentUrl = window.location.pathname;
        const eventMatch = currentUrl.match(/\/event\/([a-f0-9-]{36})/i);
        if (eventMatch) {
          eventId = eventMatch[1];
        }
      }
      
      // If no event ID provided, deny access
      if (!eventId) {
        return of(false);
      }

      // Get the event data to check privacy settings
      return service.http.get(`${service.apiUrl}/events/${eventId}`).pipe(
        map((eventData: any) => {
          
          // Check if event is private
          if (eventData && eventData.is_private === true) {
            
            // Get current user
            const currentUser = service.authService.getCurrentUser();
            if (!currentUser) {
              return false;
            }
            
            return true;
          } else {
            return true;
          }
        }),
        catchError(error => {
          
          // If it's a 403 error, it means the event exists but user doesn't have permission
          // This is expected for private/exercise events when not logged in
          if (error.status === 403) {
            return of(false);
          }
          
          // For other errors (like 404), also deny access for safety
          return of(false);
        })
      );
    }
  };
}
